module.exports = __webpack_public_path__ + "media/images/hammam-ea53073b99674e1d5e9369c78f5a38f8.svg";